module.exports = __webpack_public_path__ + "img/kat7.025aff12.jpeg";